// useAttach.ts
import { useEffect, useRef } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentUser } from '../../store/slices/currentUserSlice'
import { USER_ROUTE } from '../../common/utils/constants'
import { delayAction } from '../../common/utils/functions/delayAction'
import { getApi } from '../../api/api'

export const useAttach = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const currentUser = useSelector(selectCurrentUser)
  const api = getApi()
  const invite = searchParams.get('invite')
  const hasAttached = useRef(false)

  useEffect(() => {
    if (!invite) return
    if (hasAttached.current) return

    const handleAttach = async () => {
      hasAttached.current = true
      await delayAction(500)

      try {
        await api.linkExecutorByInvite(invite)
        searchParams.delete('invite')
        setSearchParams(searchParams)
        navigate(USER_ROUTE, { replace: true })
      } catch (error) {
        hasAttached.current = false
        // Модалка уже открыта в API методе при 401
        // Тост для других ошибок уже показан в API методе
      }
    }

    handleAttach()
  }, [invite, currentUser, dispatch, navigate, searchParams, setSearchParams, api])
}
